import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

export async function getTimeProfilesAPI() {
  const url = `${AWS_API_URL}/2n/time-profiles`;

  return getRequest(url, await authorize());
}
